import type { ReviewType } from './reviews.enum'

export class Review {
    reviewId: string
    type: ReviewType
    authorName: string
    profilePhotoUrl: string
    rating: number
    createdAt: Date
    updatedAt: Date
    text: string
    companyId: string
    personId: string
    feedback: boolean
    status: number
    sendToGoogle: boolean
}
